import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './PurchaseSuccess.css';

export default function PurchaseSuccess({ user }) {
  const { search, pathname } = useLocation();
  const sessionId = new URLSearchParams(search).get('session_id');

  useEffect(() => {
    if (!sessionId || !user) return;

    fetch(
      'https://us-central1-editvibe-90968.cloudfunctions.net/updateCredits',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionId, userId: user.uid }),
      }
    )
      .then((r) => r.json())
      .then((data) => console.log('Credits updated:', data))
      .catch((err) => console.error('Error adding credits:', err))
      .finally(() => {
        // clear the session_id so this effect won’t run again
        window.history.replaceState({}, document.title, pathname);
      });
  }, [sessionId, user, pathname]);

  return (
    <div className="purchase-success-root">
      <div className="ps-container">
        <div className="ps-bg-circles">
          <div className="ps-circle1" />
          <div className="ps-circle2" />
          <div className="ps-circle3" />
        </div>

        <h1 className="ps-title">You're in! 🎉</h1>
        <p className="ps-congrats-text">
          Credits are loaded, your plan’s live, 
          and we'll handle the monthly billing
        </p>
        <button
          id="ps-btn-continue"
          onClick={() => {
            window.location.href = 'https://app.editvibe.ai';
          }}
        >
          Time to start editing
        </button>
      </div>
    </div>
  );
}
